module.exports = __webpack_public_path__ + "static/ticket-sample-868ea7a18d30ecc46f8e3e69220ac485.png";